// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2Iuvc","info":"PatientInfo_info___zDUl"};